<template>
  <div>
    <heading :helpInfo="sidebarCard">
      {{ $t("sidebar.inspections") }}
    </heading>
    <inspectionCategoryTable />
  </div>
</template>

<script>
import inspectionCategoryTable from "@/views/inspection/inspectionCategoryTable.vue";
import * as sidebarTextDE from "../../components/api/content/sidebarText-de.json";
import * as sidebarTextEN from "../../components/api/content/sidebarText-en.json";
export default {
  name: "inspectionCategory",
  components: { inspectionCategoryTable },
  computed: {
    sidebarCard() {
      if (this.$i18n.locale == "en") {
        return sidebarTextEN.default.inspection;
      }
      return sidebarTextDE.default.inspection;
    },
  },
};
</script>
